module.exports = __webpack_public_path__ + "static/why-ati-2.5db3bdb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/why-ati-2.jpg
// module id = 537
// module chunks = 144990353498473